import {
  Directive,
  OnChanges,
  IterableDiffers,
  TemplateRef,
  SimpleChanges
} from '@angular/core';
import { CanStick, mixinHasStickyInput } from '../can-stick';
import { BaseRowDefDirective } from '../classes/base-row-def.class';
import { ERowType } from '../table.interfaces';

@Directive()
class ItrHeaderRowDefBaseDirective extends BaseRowDefDirective {}
const _ItrHeaderRowDefBase = mixinHasStickyInput(ItrHeaderRowDefBaseDirective);

@Directive({
  selector: '[itrHeaderRowDef]',
  // tslint:disable-next-line:use-input-property-decorator
  inputs: ['columns: itrHeaderRowDef', 'sticky: itrHeaderRowDefSticky']
})
export class ItrHeaderRowDefDirective extends _ItrHeaderRowDefBase
  implements CanStick, OnChanges {
  type = ERowType.HEADER;
  constructor(template: TemplateRef<any>, _differs: IterableDiffers) {
    super(template, _differs);
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
  }
}
